import { render, staticRenderFns } from "./PopUpVideo.vue?vue&type=template&id=dc178020&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./PopUpVideo.vue?vue&type=script&lang=js&"
export * from "./PopUpVideo.vue?vue&type=script&lang=js&"
import style0 from "./PopUpVideo.scss?vue&type=style&index=0&id=dc178020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc178020",
  null
  
)

export default component.exports